module.exports = "<div id=\"main_background\"></div>\n<!--<div id=\"particles-js\"></div>-->\n\n<app-navigation-bar-desktop></app-navigation-bar-desktop>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main